"use strict";

angular.module('rmStationSettings')
    .directive('rmSideMenu', require('./rm_side_menu'))
    .directive('rmSideMenuButton', require('./rm_side_menu_button'))
    .directive('rmSideMenuContent', require('./rm_side_menu_content'))
    .directive('rmSideMenuGroup', require('./rm_side_menu_group'))
    .directive('preview', function() {
        return {
            restrict: 'E',
            scope: {
                width: '@',
                height: '@',
                content: '='
            },
            link: function link(scope, element) {
                var iframe = document.createElement('iframe');
                iframe.style.width = scope.width;
                iframe.style.height = scope.height;
                iframe.style.border = 0;

                var element0 = element[0];
                element0.appendChild(iframe);

                var window = iframe.contentWindow;
                scope.$watch('content', function() {
                    window.document.open();
                    window.document.write(scope.content);
                    window.document.close();
                });
            }
        };

    })
    .directive('stringPreview', ['$compile', function( $compile ) {
        return {
            restrict: 'E',
            scope: {
                width: '@',
                height: '@',
                content: '='
            },
            link: function link(scope, element) {

                scope.$watch('content', function() {
                    element.html('<div class="marquee"><span><h1>'+scope.content+'</h1></span></div>');
                    $compile(element.contents())(scope);
                });
            }
        };
    }])

    .directive('applicationSettingsParser', require('./application_settings_parser'))

    .directive('exportCard', function() {
        return {
            restrict: 'E',
            scope: {
                activeSwitch: '=',
                cardName: '@',
                cardIcon: '@',
                lastSendMessage: '@',
                lastSend: '=',
                actionButtonText: '@',
                actionButtonFunction: '&',
                disabledTooltip: '@',
                checkDisabledFunction: '&'
            },
            transclude: true,
            templateUrl: '/partial/app.partials.stationsettings.export-card'
        }
    });

